import React from 'react';

const About = () => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>About Us</h1>
        <div style={styles.divider} />
      </div>

      <div style={styles.content}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Who We Are</h2>
          <p style={styles.paragraph}>
            Flying Jib Capital Inc. is a yield-focused asset management company structured as a
            C-corporation. We are built on the principle that disciplined capital allocation,
            combined with strategic leverage, can generate consistent and meaningful returns
            for our stakeholders.
          </p>
          <p style={styles.paragraph}>
            Our approach centers on acquiring high-yield ETFs and income-producing assets,
            financing purchases through institutional lending relationships, and managing
            our portfolio with a long-term perspective.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Our Strategy</h2>
          <p style={styles.paragraph}>
            We identify yield-producing exchange-traded funds and assets that offer
            attractive risk-adjusted returns. By leveraging our C-corp structure and
            banking relationships, we are able to borrow against our holdings to acquire
            additional assets — compounding our yield over time.
          </p>
          <p style={styles.paragraph}>
            This strategy allows us to grow our asset base methodically while maintaining
            transparency with our banking partners and stakeholders through rigorous
            financial reporting.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Our Structure</h2>
          <p style={styles.paragraph}>
            As a C-corporation, Flying Jib Capital operates with a formal corporate
            structure that supports institutional lending relationships, clear governance,
            and long-term scalability. This structure positions us to grow our balance
            sheet responsibly and sustainably.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '90vh',
    backgroundColor: '#f4f6f9',
    padding: '60px 40px',
  },
  header: {
    maxWidth: '800px',
    margin: '0 auto 48px auto',
    textAlign: 'center',
  },
  title: {
    fontSize: '42px',
    fontWeight: '700',
    color: '#0a1628',
    fontFamily: 'Georgia, serif',
    letterSpacing: '1px',
    marginBottom: '16px',
  },
  divider: {
    width: '60px',
    height: '3px',
    backgroundColor: '#0a1628',
    margin: '0 auto',
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
  },
  section: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderLeft: '3px solid #0a1628',
  },
  sectionTitle: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#0a1628',
    fontFamily: 'Georgia, serif',
    marginBottom: '16px',
    letterSpacing: '0.5px',
  },
  paragraph: {
    fontSize: '16px',
    color: '#4a6080',
    fontFamily: 'Georgia, serif',
    lineHeight: '1.9',
    marginBottom: '16px',
  },
};

export default About;